import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import Card from "../../../Components/Backoffice/Card";
import Title from "../../../Components/Backoffice/Title";
import {
  Button,
  Divider,
  Space,
  Switch,
  Upload,
  Input,
  Radio,
  Select,
  Drawer,
  Col,
  Modal,
  Row,
  DatePicker,
  notification,
  Form,
  Checkbox,
  Tag,
} from "antd";
import ImageResize from "quill-image-resize-module-react";

import { ReactComponent as IconOk } from "../../../Assets/Images/Backoffice/Ok.svg";
import { ReactComponent as IconCalendar } from "../../../Assets/Images/Backoffice/Calendar.svg";
import { ReactComponent as IconClose } from "../../../Assets/Images/Backoffice/Close.svg";
import { ReactComponent as IconEdit } from "../../../Assets/Images/Backoffice/Edit.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload.svg";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { EyeOutlined, PlusOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import axios, { all } from "axios";
import DrawerCasosRespostas from "../../../Components/Backoffice/DrawerCasosRespostas";

Quill.register("modules/imageResize", ImageResize);

const { Dragger } = Upload;

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: 7.083vw 1fr;
  min-height: 100vh;

  .icon-calendar {
    width: 22px;
  }
  .border-divider {
    border-right: 1px solid #ccc;
  }

  .btn-div-evento {
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-div-evento:hover {
    background: #ccc;
    border-radius: 2px;
  }

  .close-btn {
    border: 1px solid #494D7D !important;
    color: #494D7D !important;
    height: 45px;
    background: transparent !important;
    padding: 0 50px;
  }

  .btn-descricao {
    margin-top: 10px;
    height: 45px !important;
    padding: 0 15px;
    font-weight: bold;
  }

  .div-banner-img {
    height: 150px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background-size: cover;
    background-position: center center;
  }

  .icon-edit,
  .icon-close {
    cursor: pointer;
  }

  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #fff;
    }
  }

  @media (max-width: 992px) {
  }
`;

const Content = styled.div`
  padding: 1.771vw;
`;

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 60px;
  grid-template-columns: 1fr auto;
`;

const WrapperCardList = styled.section`
  // display: flex;
  width: 100% !important;
  flex-direction: row;

  p {
    color: #c2c4d4;
    font-size: 14px;
    letter-spacing: 0px;
    line-height: 20px;
    margin-bottom: 0% !important;
    text-align: left;
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .css-dev-only-do-not-override-j0nf2s .text {
    margin-bottom: 0 !important;
  }

  .action-edit {
    cursor: pointer;
    color: #494d7d;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }
`;

const WrapperCardEvento = styled.section`
  display: flex;
  flex-direction: column;

  .grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 20px;
  }

  .ant-upload-btn {
  min-height: 190px;
}

  .ant-radio-button-wrapper {
    height: 45px;
    border: 1px solid rgb(128, 159, 184);
  }

  .ant-radio-button-wrapper span {
    line-height: 45px; 
    font-size: 14px;s
  }
  .text {
    margin-bottom: 0% !important;
  }

  h4 {
    text-align: center;
    font: normal normal bold 20px/20px Roboto;
    letter-spacing: 0px;
    color: #050505;
  }
  

  .text {
    color: #809FB8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .center {
    text-align: center;
  }

  .ant-upload-wrapper .ant-upload-drag {
    max-height: -webkit-fill-available;
    height: 91%;
    display: flex;
    justify-content: center;
  }

  .ant-upload-wrapper .ant-upload-drag .ant-upload-btn  {
    height: -webkit-fill-available;
  }


  .cta {
    display: block !important;
    font-size: 15px;
    padding: 0 30px !important;
    font-weight: bold;
    height: 45px !important;
    line-height: 18px;
    width: fit-content;

    i { margin: 0 3px; }

    a { text-decoration: none; }
  }

  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #FFF;
    }
  }
`;

var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "5px",
    marginBottom: "2px"
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerEvents: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    width: "100%",
  },
  select_class: {
    borderRadius: "6px",
    height: "45px",
    color: "#0C1151",
    width: "100%",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "45px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #809FB8",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

export default function DashboardCasoDoMes(props) {
  document.title = "SPAP - Caso do Mês";
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const formRef = useRef();
  const formRef2 = useRef();
  const [formRefEdit] = Form.useForm();

  const [fileCasoList, setfileCasoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [areaEvent, setAreaEvent] = useState([]);
  const [descricaoEvent, setDescricaoEvent] = useState("");
  const [descricaoCurtaEvent, setDescricaoCurtaEvent] = useState("");
  const [tituloEvent, setTituloEvent] = useState("");
  const [agendarPost, setAgendarPostEvent] = useState("");
  const [autorEvent, setAutorEvent] = useState("");
  const [instituicaoEvent, setInstituicaoEvent] = useState("");
  const [questaoEvent, setQuestaoEvent] = useState("");
  const [questaoEvent2, setQuestaoEvent2] = useState("");
  const [respostasEvent, setRespostasEvent] = useState("");
  const [respostasEvent2, setRespostasEvent2] = useState("");
  const [showEventDrawer, setShowEventDrawer] = useState(false);
  // editar evento
  const [fileEventListEdit, setfileEventListEdit] = useState([]);
  const [eventIdEdit, setEventIdEdit] = useState("");
  const [dataEditEvent, setDataEditEvent] = useState([]);
  const [descricaoEventEdit, setDescricaoEventEdit] = useState("");
  const [descricaoCurtaEventEdit, setDescricaoCurtaEventEdit] = useState("");
  const [tituloEventEdit, setTituloEventEdit] = useState("");
  const [tipoEventEdit, setTipoEventEdit] = useState("");
  const [autorEventEdit, setAutorEventEdit] = useState("");
  const [instituicaoEventEdit, setInstituicaoEventEdit] = useState("");
  const [questaoEventEdit, setQuestaoEventEdit] = useState("");
  const [questaoEvent2Edit, setQuestaoEvent2Edit] = useState("");
  const [respostasEventEdit, setRespostasEventEdit] = useState("");
  const [respostasEvent2Edit, setRespostasEvent2Edit] = useState("");
  const [editModeDescricao, setEditModeDescricao] = useState(false);

  const [areaEdit, setAreaEdit] = useState("");
  const [imagemDestaqueEdit, setImagemDestaqueEdit] = useState("");
  const [noticiaEvent, setNoticiaEvent] = useState(false);
  const [bolsaPremioEvent, setBolsaPremioEvent] = useState(false);
  const [removeCasoModalOpen, setRemoveCasoModalOpen] = useState(false);
  const [idToRemove, setIdToRemove] = useState(false);
  const [titleToRemove, setTitleToRemove] = useState(false);
  const [drawerRespostas, setDrawerRespostas] = useState(false);
  const [casoDrawer, setCasoDrawer] = useState(null);
  const [respostasDrawer, setRespostasDrawer] = useState(null);
  const [respostas, setRespostas] = useState([]);

  const dateFormat = "MM/YYYY";

  const [allItems, setAllItems] = useState([]);
  const [currentItemsEvent, setCurrentItemsEvent] = useState(
    allItems?.slice(0, 2)
  );

  const [itemOffsetEvent, setItemOffsetEvent] = useState(0);
  const itemsPerPageEvent = 2;

  function formatarMesAno(data) {
    if (typeof data !== "string") return "";

    const partes = data.split("/");
    if (partes.length < 2) return "";

    const mes = parseInt(partes[0], 10) - 1;
    const ano = partes[1];

    const nomesMeses = [
      "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    return `${nomesMeses[mes] || "Mês inválido"} ${ano}`;
  }

  const formatDate = (date) => {
    const parts = date.split("T")[0].split("-");

    // Obtendo os componentes da data
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];

    // Formatando a data como "DD/MM/YYYY"
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  const getCasos = (allItens) => {
    if (allItens?.length > 0) {
      allItens.map((item) => {
        item.url = item.imagem_destaque
          ? "https://api.spap.pt/caso_do_mes/" +
            item.id +
            "/" +
            item.imagem_destaque
          : "https://api.spap.pt/clubes/clube-estudo-default.svg";

        item.date = formatarMesAno(item.agendar_post);
      });

      setAllItems(
        allItens.sort((a, b) => {
          if (!a.agendar_post || !b.agendar_post) return 0;

          const [mesA, anoA] = a.agendar_post.split("/").map(Number);
          const [mesB, anoB] = b.agendar_post.split("/").map(Number);

          const dataA = new Date(anoA, mesA - 1);
          const dataB = new Date(anoB, mesB - 1);

          return dataB - dataA;
        })
      );
    }
  };

  useEffect(() => {
    fetch(`https://api.spap.pt/api/all-casos-do-mes`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar eventos");
        }
        return response.json();
      })
      .then((data) => {
        if (data.length === 0) {
          console.log("nenhum evento");
        }
        getCasos(data.caso_do_mes);
        setRespostas(data.respostas);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const endOffset = itemOffsetEvent + itemsPerPageEvent;
    setCurrentItemsEvent(allItems?.slice(itemOffsetEvent, endOffset));
  }, [itemOffsetEvent, allItems]);

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const showModal = (e) => {
    setQuotaToUpdate(e);
    setIsModalOpen(true);
  };

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const clickToEventDrawer = (item) => {
    setEditModeDescricao(false);
    setEventIdEdit(item.id);
    setDescricaoEventEdit(item.descricao);
    setDescricaoCurtaEventEdit(item.descricao_curta);
    setTituloEventEdit(item.titulo);
    setTipoEventEdit(item.is_spap);
    setImagemDestaqueEdit(item.imagem_destaque);
    setAreaEdit(item.area_subespecializacao);
    setAutorEventEdit(item.autor);
    setInstituicaoEventEdit(item.instituicao);
    setQuestaoEventEdit(item.questao);
    setRespostasEventEdit(item.respostas);
    setQuestaoEvent2Edit(item.questao_2);
    setRespostasEvent2Edit(item.respostas_2);

    setRespostasCheckEdit("");

    if (formRefEdit?.getFieldValue("respostas")?.length > 0) {
      formRefEdit.resetFields();
    }

    if (JSON.parse(item.respostas)?.length > 0) {
      formRefEdit?.setFieldsValue({
        respostas: JSON.parse(item.respostas),
      });
      for (let index = 0; index < JSON.parse(item.respostas)?.length; index++) {
        if (JSON.parse(item.respostas)[index].resposta === true)
          setRespostasCheckEdit(index);
      }
    }

    if (JSON.parse(item.respostas_2)?.length > 0) {
      formRefEdit?.setFieldsValue({
        respostas_2: JSON.parse(item.respostas_2),
      });
      for (let index = 0; index < JSON.parse(item.respostas_2)?.length; index++) {
        if (JSON.parse(item.respostas_2)[index].resposta === true)
          setRespostasCheckEdit2(index);
      }
    }

    setShowEventDrawer(true);
  };

  const propEvent = {
    onRemove: (file) => {
      const index = fileCasoList.indexOf(file);
      const newfileEventList = fileCasoList.slice();
      newfileEventList.splice(index, 1);
      setfileCasoList(newfileEventList);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });

        return isImage || Upload.LIST_IGNORE;
      }
      setfileCasoList([...fileCasoList, file]);
      return false;
    },
    fileCasoList,
  };

  const t = 1;
  const data = [];

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageResize: {
      // parchment: Quill.import('parchment'),
      modules: ["Resize", "DisplaySize"],
    }
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    'align',
    "link",
    "image",
    "video",
  ];

  const onChangeDatePost = (date, dateString) => {
    setAgendarPostEvent(dateString);
  };

  const handleEvent = (e) => {

    if (
      tituloEvent.length == 0 ||
      descricaoEvent.length == 0 ||
      descricaoCurtaEvent.length == 0 ||
      fileCasoList.length == 0 || agendarPost?.length == 0
    ) {
      notification.error({
        description: "Para criar um novo caso, preencha todos os campos.",
      });
      return;
    }

    if (allItems?.filter((item) => { return item.agendar_post == agendarPost}).length > 0) {
      notification.error({
        description: "Já existe um caso do mês para o mês definido.",
      });
      return;
    }

    /* pegar respostas */
    const respostasValues = formRef.current.getFieldsValue();
    let newRespostas = [];
    for (let index = 0; index < respostasValues.respostas?.length; index++) {
      let arrayToPush = [];
      if (respostasValues.respostas[index] !== undefined) {
        arrayToPush.texto = respostasValues.respostas[index].texto;
      }
      index === respostasCheck
        ? (arrayToPush.resposta = true)
        : (arrayToPush.resposta = false);
      newRespostas.push({
        texto: arrayToPush.texto,
        resposta: arrayToPush.resposta,
      });
    }

    const respostasValues2 = formRef2.current.getFieldsValue();
    let newRespostas2 = [];
    for (let index = 0; index < respostasValues2.respostas?.length; index++) {
      let arrayToPush = [];
      if (respostasValues2.respostas[index] !== undefined) {
        arrayToPush.texto = respostasValues.respostas[index].texto;
      }
      index === respostasCheck2
        ? (arrayToPush.resposta = true)
        : (arrayToPush.resposta = false);
      newRespostas2.push({
        texto: arrayToPush.texto,
        resposta: arrayToPush.resposta,
      });
    }

    const formData = new FormData();

    formData.append("titulo", tituloEvent);
    formData.append("file", fileCasoList[0]);
    formData.append("descricao", descricaoEvent);
    formData.append("descricao_curta", descricaoEvent);
    formData.append("agendarPost", agendarPost);
    formData.append("area", areaEvent);
    formData.append("autor", autorEvent);
    formData.append("instituicao", instituicaoEvent);
    formData.append("questao", questaoEvent);
    formData.append("respostas", JSON.stringify(newRespostas));
    formData.append("questao_2", questaoEvent2);
    formData.append("respostas_2", JSON.stringify(newRespostas2));

    // You can use any AJAX library you like
    fetch("https://api.spap.pt/api/admin/store-caso-do-mes", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            if (data.message == "already_exists") {
              notification.error({
                description: "Já existe um caso do mês com o mesmo nome!",
              });
            } else {
              getCasos(data.casos_do_mes);
              setShowForm(false);
              notification.success({
                description: "O caso foi criado com sucesso!",
              });
              const endOffset = itemOffsetEvent + itemsPerPageEvent;
              setCurrentItemsEvent(allItems.slice(itemOffsetEvent, endOffset));
              setTituloEvent("");
              setDescricaoEvent("");
              setAreaEvent([]);
              setAutorEvent("");
              setInstituicaoEvent("");
              setQuestaoEvent("");
              setRespostasEvent("");
              setRespostasCheck("");
              setQuestao2Event("");
              setRespostas2Event("");
              setRespostasCheck2("");
              setAgendarPostEvent("");
              setfileCasoList([]);
              formRef.current.resetFields();
            }
          })
          .catch((err) => {});
      })
      .then(() => {})
      .catch(() => {})
      .finally(() => {});
  };

  const propEventEdit = {
    onRemove: (file) => {
      fileEventListEdit([]);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });
        setfileEventListEdit((current) => []);
        return Upload.LIST_IGNORE;
      }
      setfileEventListEdit([...fileEventListEdit, file]);
    },
    fileEventListEdit,
  };

  const handleEditEvent = () => {
    if (descricaoEventEdit.length == 0 || tituloEventEdit.length == 0) {
      notification.error({
        description: "Para editar o evento, preencha os campos respetivos.",
      });
      return;
    }

    /* pegar respostas */
    const respostasValues = formRefEdit.getFieldsValue();
    let newRespostas = [];
    for (let index = 0; index < respostasValues.respostas?.length; index++) {
      let arrayToPush = [];
      if (respostasValues.respostas[index] !== undefined) {
        arrayToPush.texto = respostasValues.respostas[index].texto;
      }
      index === respostasCheckEdit
        ? (arrayToPush.resposta = true)
        : (arrayToPush.resposta = false);
      newRespostas.push({
        texto: arrayToPush.texto,
        resposta: arrayToPush.resposta,
      });
    }

    let newRespostas2 = [];
    for (let index = 0; index < respostasValues.respostas_2?.length; index++) {
      let arrayToPush = [];
      if (respostasValues.respostas_2[index] !== undefined) {
        arrayToPush.texto = respostasValues.respostas_2[index].texto;
      }
      index === respostasCheckEdit2
        ? (arrayToPush.resposta = true)
        : (arrayToPush.resposta = false);
      newRespostas2.push({
        texto: arrayToPush.texto,
        resposta: arrayToPush.resposta,
      });
    }

    const formData = new FormData();

    if (fileEventListEdit.length) {
      formData.append("file", fileEventListEdit[0]);
    }

    formData.append("titulo", tituloEventEdit);
    formData.append("casoId", eventIdEdit);
    formData.append("descricao", descricaoEventEdit);
    formData.append("descricao_curta", descricaoCurtaEventEdit);
    formData.append("area", areaEdit);
    formData.append("autor", autorEventEdit);
    formData.append("instituicao", instituicaoEventEdit);
    formData.append("questao", questaoEventEdit);
    formData.append("respostas", JSON.stringify(newRespostas));
    formData.append("questao_2", questaoEvent2Edit);
    formData.append("respostas_2", JSON.stringify(newRespostas2));

    setUploading(true);

    // You can use any AJAX library you
    fetch("https://api.spap.pt/api/admin/update-caso-do-mes", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            getCasos(data.caso_do_mes);
            setShowEventDrawer(false);
            const endOffset = itemOffsetEvent + itemsPerPageEvent;
            setCurrentItemsEvent(allItems.slice(itemOffsetEvent, endOffset));
          })
          .catch((err) => {});
      })
      .then(() => {
        setfileEventListEdit([]);
        notification.success({
          description: "O caso do mês foi atualizado com sucesso!",
        });
      })
      .catch(() => {
        notification.error({
          description: "Já existe um caso do mês com o mesmo nome neste clube!",
        });
      })
      .finally(() => {});
  };

  const handleRemoveEvent = () => {
    axios
      .post(
        "https://api.spap.pt/api/admin/remove-caso-do-mes",
        { idToRemove },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      )
      .then((res) => {
        setIdToRemove("");
        setRemoveCasoModalOpen(false);
        if (res.status == 200) {
          getCasos(res.data.caso_do_mes);
          const endOffset = itemOffsetEvent + itemsPerPageEvent;
          setCurrentItemsEvent(allItems.slice(itemOffsetEvent, endOffset));
          notification.success({
            description: "O caso do mês foi removido com sucesso!",
          });
        }
      })
      .catch((error) => {
        // notification.error({description: 'Erro ao remover a imagem da galeria! Tente novamente.'});
      });
  };

  const openRemoveCasoModal = (id, titulo) => {
    setIdToRemove(id);
    setTitleToRemove(titulo);
    setRemoveCasoModalOpen(true);
  };


  const openDrawerEventPayments = (item) => {
    setCasoDrawer(item);
    let respostasCaso = respostas.filter((resposta) => { return resposta.id_caso_do_mes == item.id });
    setRespostasDrawer(respostasCaso);
    setDrawerRespostas(true);
  };

  const validateVerdadeiraRadio = (_, value, callback) => {
    if (!value) {
      callback("Selecione uma única questão como verdadeira");
    } else {
      callback();
    }
  };

  const [respostasCheck, setRespostasCheck] = useState([]);
  const [respostasCheck2, setRespostasCheck2] = useState([]);
  const handleRemoveCheckbox = (remove, field, index) => {
    remove(field.name);
    // Chame sua função aqui após remover a linha
    if (respostasCheck === index) setRespostasCheck("");
  };


  const handleRemoveCheckbox2 = (remove, field, index) => {
    remove(field.name);
    // Chame sua função aqui após remover a linha
    if (respostasCheck2 === index) setRespostasCheck2("");
  };

  const [respostasCheckEdit, setRespostasCheckEdit] = useState([]);
  const [respostasCheckEdit2, setRespostasCheckEdit2] = useState([]);
  const handleRemoveCheckboxEdit = (remove, field, index) => {
    remove(field.name);
    // Chame sua função aqui após remover a linha
    if (respostasCheckEdit === index) setRespostasCheckEdit("");
  };
  const handleRemoveCheckboxEdit2 = (remove, field, index) => {
    remove(field.name);
    // Chame sua função aqui após remover a linha
    if (respostasCheckEdit2 === index) setRespostasCheckEdit2("");
  };

  const editDescricao = () => {
    setDescricaoEventEdit(descricaoEventEdit);
    setEditModeDescricao(true);
  };

  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />
        <WrapperCardEvento>
          <Card>
            <CardHeader>
              <div>
              <Title>Caso do Mês</Title>
              <p className="text mt-10">
                <i>Casos disponíveis para consultar na página Caso do Mês</i>
              </p>
              </div>
              <Space>
              { showForm == false && 
              <Button
                onClick={() => setShowForm(true)}
                style={{
                  background: "#494D7D",
                  color: "#fff",
                  borderRadius: "6px",
                  height: "45px",
                  display: "flex",
                  fontWeight: "bold",
                  alignItems: "center",
                  padding: "0 30px",
                }}
              >
                <PlusOutlined /> Novo Caso do mês
              </Button>}
              { showForm == true && 
              <DatePicker
                placement="bottomRight"
                style={{
                  width: "200px",
                  height: "45px",
                  border: "1px solid rgb(128, 159, 184)",
                }}
                format={dateFormat}
                placeholder="Data Publicação"
                picker="month"
                onChange={onChangeDatePost}
              />}
              </Space>
            </CardHeader>
            { showForm == true && 
            <>
            <Divider style={{ margin: '12px 0'}}/>
            <Row gutter={[12, 18]} align="bottom">
              <Col span={14}>
                <label className="text">Título do Caso</label>
                <Input
                  key={"titulo-event"}
                  placeholder="Título"
                  name="titulo"
                  style={styles.input_class}
                  value={tituloEvent}
                  onChange={(e) => setTituloEvent(e.target.value)}
                />
              </Col>
              <Col span={10}>
                <label className="text">Área de Diferenciação</label>
                <Select
                  key={"area-evento"}
                  placeholder="Área de Diferenciação"
                  value={areaEvent ? areaEvent : ""}
                  style={styles.select_class}
                  onChange={(e) => setAreaEvent(e)}
                  options={[
                    { value: "Patologia geral", label: "Patologia geral" },
                    { value: "Citologia", label: "Citologia" },
                    { value: "Patologia cutânea", label: "Patologia cutânea" },
                    {
                      value: "Patologia da cabeça e pescoço",
                      label: "Patologia da cabeça e pescoço",
                    },
                    {
                      value: "Patologia das partes moles",
                      label: "Patologia das partes moles",
                    },
                    {
                      value: "Patologia do sistema nervosa",
                      label: "Patologia do sistema nervoso",
                    },
                    { value: "Patologia digital", label: "Patologia digital" },
                    {
                      value: "Patologia endócrina",
                      label: "Patologia endócrina",
                    },
                    {
                      value: "Patologia fetoplacentar",
                      label: "Patologia fetoplacentar",
                    },
                    {
                      value: "Patologia gastrointestinal",
                      label: "Patologia gastrointestinal",
                    },
                    {
                      value: "Patologia ginecológica",
                      label: "Patologia ginecológica",
                    },
                    {
                      value: "Patologia hematolinfoide",
                      label: "Patologia hematolinfoide",
                    },
                    {
                      value: "Patologia hepatobiliar",
                      label: "Patologia hepatobiliar",
                    },
                    { value: "Patologia mamária", label: "Patologia mamária" },
                    {
                      value: "Patologia molecular",
                      label: "Patologia molecular",
                    },
                    {
                      value: "Patologia osteoarticular",
                      label: "Patologia osteoarticular",
                    },
                    {
                      value: "Patologia pancreática",
                      label: "Patologia pancreática",
                    },
                    {
                      value: "Patologia pulmonar",
                      label: "Patologia pulmonar",
                    },
                    {
                      value: "Patologia urogenital",
                      label: "Patologia urogenital",
                    },
                  ]}
                />
              </Col>
            </Row>

            <Row gutter={[12, 12]} style={{ marginTop: "10px" }} align={"top"}>
              <Col span={6}>
                <p
                  className="text"
                  style={{ marginBottom: "0px" }}
                  align="center"
                >
                  Tamanho máximo de upload (1 MB)
                </p>
                <Dragger
                  {...propEvent}
                  style={{ height: "100%" }}
                  fileList={[...fileCasoList]}
                >
                  <p className="ant-upload-drag-icon">
                    <IconUpload />
                  </p>
                  <p className="ant-upload-text text">
                    Upload da imagem do evento
                  </p>
                  <p className="ant-upload-hint">Faça Drag and drop aqui</p>
                </Dragger>
                <label className="text mt-10" rows={10} style={{ marginBottom: "0px" }} >
                  Descrição curta
                </label>
                <Input.TextArea placeholder="Descrição" className="textarea-input" rows={8} 
                      value={descricaoCurtaEvent}
                      onChange={(e) => setDescricaoCurtaEvent(e.target.value)}/>

              </Col>
              <Col span={18}>
                <Row
                  gutter={[12, 12]}
                  style={{ marginTop: "10px" }}
                  align={"top"}
                >
                  <Col span={12}>
                    <label className="text" style={{ marginBottom: "0px" }}>
                      Autor
                    </label>
                    <Input
                      placeholder="Autor"
                      name="autor"
                      style={styles.input_class}
                      value={autorEvent}
                      onChange={(e) => setAutorEvent(e.target.value)}
                    />
                  </Col>
                  <Col span={12}>
                    <label className="text" style={{ marginBottom: "0px" }}>
                      Instituição
                    </label>
                    <Input
                      placeholder="Instituição"
                      name="instituicao"
                      style={styles.input_class}
                      value={instituicaoEvent}
                      onChange={(e) => setInstituicaoEvent(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }} align={"top"}>
                  <Col span={24}>
                    <label className="text" style={{ marginBottom: "0px" }}>
                      Descrição
                    </label>
                    <ReactQuill
                      key={"descricao-evento"}
                      placeholder="Descrição"
                      modules={modules}
                      formats={formats}
                      theme="snow"
                      name="descricao"
                      onChange={(e) => setDescricaoEvent(e)}
                      value={descricaoEvent}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }} align={"top"}>
                  <Col span={24}>
                    <label className="text" style={{ marginBottom: "0px" }}>
                      Questão
                    </label>
                    <Input
                      placeholder="Questão"
                      name="questao"
                      style={styles.input_class}
                      value={questaoEvent}
                      onChange={(e) => setQuestaoEvent(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }} align={"middle"}>
                  <Col span={24}>
                    <Form ref={formRef} className="edit-post-form">
                      <Form.List
                        name="respostas"
                        rules={[{ validator: validateVerdadeiraRadio }]}
                      >
                        {(fields, { add, remove }) => (
                          <Row gutter={[12, 12]}>
                            <Col span={6}>
                              <Form.Item>
                                <Button
                                  type="primary"
                                  className="cta"
                                  onClick={() => add()}
                                  block
                                >
                                  Adicionar Resposta
                                </Button>
                              </Form.Item>
                            </Col>
                            <Col span={18}>
                              {fields.map((field, index) => (
                                <Form.Item key={field.key}>
                                  <Row gutter={[12, 12]} align={"middle"}>
                                    <Col span={18}>
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "texto"]}
                                        rules={[
                                          {
                                            required: true,
                                            message:
                                              "Digite o texto da questão",
                                          },
                                        ]}
                                      >
                                        <Input
                                          placeholder={
                                            "Resposta " + (index + 1)
                                          }
                                          style={styles.input_class}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={4} align="">
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "resposta_"]}
                                      >
                                        <Checkbox
                                          checked={
                                            respostasCheck === index && true
                                          }
                                          onClick={(e) => {
                                            setRespostasCheck(index);
                                          }}
                                        >
                                          Verdadeira
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col span={2} align="">
                                      <IconClose
                                        className="icon icon-close"
                                        onClick={() =>
                                          handleRemoveCheckbox(
                                            remove,
                                            field,
                                            index
                                          )
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Form.Item>
                              ))}
                            </Col>
                          </Row>
                        )}
                      </Form.List>
                    </Form>
                  </Col>
                </Row>
                <Row  align={"top"}>
                  <Col span={24}>
                    <label className="text">
                      Questão 2 (opcional)
                    </label>
                    <Input
                      placeholder="Questão"
                      name="questao"
                      style={styles.input_class}
                      value={questaoEvent2}
                      onChange={(e) => setQuestaoEvent2(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row  style={{ marginTop: "10px" }} align={"middle"}>
                  <Col span={24}>
                    <Form ref={formRef2} className="edit-post-form">
                      <Form.List
                        name="respostas"
                        rules={[{ validator: validateVerdadeiraRadio }]}
                      >
                        {(fields, { add, remove }) => (
                          <Row gutter={[12, 12]}>
                            <Col span={6}>
                              <Form.Item>
                                <Button
                                  type="primary"
                                  className="cta"
                                  onClick={() => add()}
                                  block
                                >
                                  Adicionar Resposta
                                </Button>
                              </Form.Item>
                            </Col>
                            <Col span={18}>
                              {fields.map((field, index) => (
                                <Form.Item key={'questao2_' + field.key}>
                                  <Row gutter={[12, 12]} align={"middle"}>
                                    <Col span={18}>
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "texto"]}
                                        rules={[
                                          {
                                            required: true,
                                            message:
                                              "Digite o texto da questão",
                                          },
                                        ]}
                                      >
                                        <Input
                                          placeholder={
                                            "Resposta " + (index + 1)
                                          }
                                          style={styles.input_class}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={4} align="">
                                      <Form.Item
                                        {...field}
                                        name={[field.name, "resposta"]}
                                      >
                                        <Checkbox
                                          checked={
                                            respostasCheck2 === index && true
                                          }
                                          onClick={(e) => {
                                            setRespostasCheck2(index);
                                          }}
                                        >
                                          Verdadeira
                                        </Checkbox>
                                      </Form.Item>
                                    </Col>
                                    <Col span={2} align="">
                                      <IconClose
                                        className="icon icon-close"
                                        onClick={() =>
                                          handleRemoveCheckbox2(
                                            remove,
                                            field,
                                            index
                                          )
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Form.Item>
                              ))}
                            </Col>
                          </Row>
                        )}
                      </Form.List>
                    </Form>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "8px 0" }} />
            <Row justify={'end'}>
              <Space size={10}>
                <Button
                  onClick={() => setShowForm(false)}
                  className="close-btn hide-event"
                >
                  Fechar
                </Button>
                <Button
                  type="primary"
                  className="cta publish"
                  onClick={handleEvent}
                  align="end"
                >
                  Publicar <IconOk className="icon icon-ok" />
                </Button>
              </Space>
            </Row>
            </>}
          </Card>

          <WrapperCardList>
            <Row gutter={[8,0]} className="flex-wrap">
              {allItems?.map((item, index) => {
                let textPreview = item.descricao
                  .replace(/<(h2|h3|img|b|strong)[^>]*>/g, "<p>")
                  .slice(0, 140);
                if (item.descricao.length > 140) textPreview += " (...)";
                return (
                  <Col span={8}>
                    <Card key={"caso_do_mes-" + item.id} className="space-between flex-vertical">

                      <div className="h-100">
                      <CardHeader>
                        <Title>{item.titulo}</Title>
                        <Space>
                        
                        {item.date.length > 4 &&
                          <>
                        <Tag>
                          <Space>
                            <IconCalendar className="icon icon-calendar" />
                             <span className="text">{item.date}</span>
                          </Space>
                        </Tag></>}
                        <IconClose
                          className="icon icon-close"
                          onClick={() =>
                            openRemoveCasoModal(item.id, item.titulo)
                          }
                        />
                          </Space>
                      </CardHeader>
                      <div
                       className="reticencias"
                        style={{ fontSize: "12px", lineHeight: "1.4" }}
                        dangerouslySetInnerHTML={{ __html: textPreview }}
                      ></div>

                      </div>
                      <Space direction="vertical" style={{ width: "100%" }}>
                          <Row>
                            <Col
                              span={8}
                              align="center"
                              className="border-divider btn-div-evento"
                              key={"editEvent-" + index}
                              onClick={() => clickToEventDrawer(item)}
                            >
                              <SettingOutlined />
                            </Col>
                            <Col
                              span={8}
                              align="center"
                              className="border-divider btn-div-evento"
                              key={"editEventNaoDefinidosPayment-" + index}
                              onClick={(e) => {
                                e.preventDefault();
                                openDrawerEventPayments(item);
                              }}
                            >
                              <UserOutlined />
                            </Col>
                            <Col
                              span={8}
                              align="center"
                              onClick={() => {
                                window.open(
                                  "https://spap.pt/ferramentas-uteis/caso-do-mes/" + item.id,
                                  "_blank"
                                );
                              }}
                              className="btn-div-evento"
                            >
                              <EyeOutlined />
                            </Col>
                          </Row>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </Row>

            <Drawer
              key={"editar-evento-" + eventIdEdit}
              title="Editar Evento"
              width={900}
              onClose={() => setShowEventDrawer(false)}
              open={showEventDrawer}
              bodyStyle={{
                paddingBottom: 80,
              }}
              className="edit-post-form"
              extra={
                <Space>
                  <Button onClick={() => setShowEventDrawer(false)}>
                    Cancelar
                  </Button>
                  <Button
                    onClick={handleEditEvent}
                    type="submit"
                    style={{
                      borderRadius: "6px",
                      background: "#494D7D",
                      color: "#fff",
                    }}
                  >
                    Guardar
                  </Button>
                </Space>
              }
            >
              <Form form={formRefEdit}>
                <Col>
                  <Row align={"middle"}>
                    <Col span={12}>
                      <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>
                        Upload da imagem
                      </h5>
                      <p>
                        Poderá fazer o upload de uma nova imagem de destaque
                        clicando na imagem do lado direito.
                      </p>
                    </Col>
                    <Col span={12}>
                      <Dragger
                        {...propEventEdit}
                        fileList={[...fileEventListEdit]}
                        style={{
                          marginBottom: "5px",
                          width: "100%",
                          backgroundImage:
                            "url(https://api.spap.pt/caso_do_mes/" +
                            eventIdEdit +
                            "/" +
                            imagemDestaqueEdit +
                            ")",
                          backgroundSize: "cover",
                        }}
                      >
                        <div style={{ opacity: 0 }}>
                          <p className="ant-upload-drag-icon">
                            <IconUpload />
                          </p>
                          <p className="ant-upload-text text">
                            Upload da imagem{" "}
                          </p>
                          <p className="ant-upload-hint">
                            Faça Drag and drop aqui
                          </p>
                        </div>
                      </Dragger>
                    </Col>
                  </Row>
                  <Divider
                    style={{ background: "#fff", margin: "12px 0" }}
                  ></Divider>
                  <Row
                    className="row-drawer"
                    gutter={[8, 8]}
                    style={{ flexFlow: "column !important" }}
                  >
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Título</h6>
                      <Input
                        key={"titulo-evento-" + eventIdEdit}
                        placeholder="Título"
                        name="titulo"
                        style={styles.input_class}
                        defaultValue={tituloEventEdit}
                        onChange={(e) => setTituloEventEdit(e.target.value)}
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Área de Diferenciação</h6>
                      <Select
                        key={"area-evento-" + eventIdEdit}
                        value={areaEdit}
                        style={styles.select_class}
                        placeholder="Área de Diferenciação"
                        onChange={(e) => setAreaEdit(e)}
                        options={[
                          {
                            value: "Patologia geral",
                            label: "Patologia geral",
                          },
                          { value: "Citologia", label: "Citologia" },
                          {
                            value: "Patologia cutânea",
                            label: "Patologia cutânea",
                          },
                          {
                            value: "Patologia da cabeça e pescoço",
                            label: "Patologia da cabeça e pescoço",
                          },
                          {
                            value: "Patologia das partes moles",
                            label: "Patologia das partes moles",
                          },
                          {
                            value: "Patologia do sistema nervosa",
                            label: "Patologia do sistema nervoso",
                          },
                          {
                            value: "Patologia digital",
                            label: "Patologia digital",
                          },
                          {
                            value: "Patologia endócrina",
                            label: "Patologia endócrina",
                          },
                          {
                            value: "Patologia fetoplacentar",
                            label: "Patologia fetoplacentar",
                          },
                          {
                            value: "Patologia gastrointestinal",
                            label: "Patologia gastrointestinal",
                          },
                          {
                            value: "Patologia ginecológica",
                            label: "Patologia ginecológica",
                          },
                          {
                            value: "Patologia hematolinfoide",
                            label: "Patologia hematolinfoide",
                          },
                          {
                            value: "Patologia hepatobiliar",
                            label: "Patologia hepatobiliar",
                          },
                          {
                            value: "Patologia mamária",
                            label: "Patologia mamária",
                          },
                          {
                            value: "Patologia molecular",
                            label: "Patologia molecular",
                          },
                          {
                            value: "Patologia osteoarticular",
                            label: "Patologia osteoarticular",
                          },
                          {
                            value: "Patologia pancreática",
                            label: "Patologia pancreática",
                          },
                          {
                            value: "Patologia pulmonar",
                            label: "Patologia pulmonar",
                          },
                          {
                            value: "Patologia urogenital",
                            label: "Patologia urogenital",
                          },
                        ]}
                      />{" "}
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Autor</h6>
                      <Input
                        placeholder="Autor"
                        name="autor"
                        style={styles.input_class}
                        value={autorEventEdit}
                        onChange={(e) => setAutorEventEdit(e.target.value)}
                      />
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Instituição</h6>
                      <Input
                        placeholder="Instituição"
                        name="instituicao"
                        style={styles.input_class}
                        value={instituicaoEventEdit}
                        onChange={(e) =>
                          setInstituicaoEventEdit(e.target.value)
                        }
                      />
                    </Col>
                      {/* <Col span={24}>
                      <h6 style={styles.h6_label}>Descrição Curta</h6>
                        <Input.TextArea
                          key={"descricao-curta-evento"}
                          placeholder="Descrição"
                          className="textarea-input"
                          onChange={(e) => setDescricaoCurtaEventEdit(e.target.value)}
                          value={descricaoCurtaEventEdit}
                        />
                      </Col> */}
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Descrição</h6>

                      {!editModeDescricao && (
                        <>
                          <Button onClick={() => editDescricao()}>Editar</Button>
                          <br />
                          <br />
                          <div
                            className="event__content"
                            dangerouslySetInnerHTML={{ __html: descricaoEventEdit }}
                          ></div>
                        </>
                      )}
                      {editModeDescricao && (
                        <ReactQuill
                          key={"descricao-evento"}
                          modules={modules}
                          formats={formats}
                          theme="snow"
                          name="descricao"
                          value={descricaoEventEdit}
                          onChange={(e) => setDescricaoEventEdit(e)}
                        />
                      )}
                      {/* <ReactQuill
                        key={"descricao-evento-" + eventIdEdit}
                        modules={modules}
                        formats={formats}
                        theme="snow"
                        name="descricao"
                        onChange={(e) => setDescricaoEventEdit(e)}
                        defaultValue={descricaoEventEdit}
                      /> */}
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Questão</h6>
                      <Input
                        placeholder="Questão"
                        name="questao"
                        style={styles.input_class}
                        value={questaoEventEdit}
                        onChange={(e) => setQuestaoEventEdit(e.target.value)}
                      />
                    </Col>
                    <Col span={24}>
                        <Form.List
                          name="respostas"
                          rules={[{ validator: validateVerdadeiraRadio }]}
                        >
                          {(fields, { add, remove }) => (
                            <Row gutter={[12, 12]}>
                              <Col span={6}>
                                <Form.Item>
                                  <Button
                                    type="primary"
                                    className="cta publish h-45"
                                    onClick={() => add()}
                                    block
                                  >
                                    Adicionar Resposta
                                  </Button>
                                </Form.Item>
                              </Col>
                              <Col span={18}>
                                {fields.map((field, index) => (
                                  <Form.Item key={field.key}>
                                    <Row gutter={[12, 12]} align={'middle'}>
                                      <Col span={18}>
                                        <Form.Item
                                          {...field}
                                          name={[field.name, "texto"]}
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Digite o texto da questão",
                                            },
                                          ]}
                                        >
                                          <Input
                                            placeholder={
                                              "Resposta " + (index + 1)
                                            }
                                            style={styles.input_class}
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col span={4} align="center">
                                        <Form.Item
                                          {...field}
                                          name={[field.name, "resposta"]}
                                        >
                                          <Checkbox
                                            checked={
                                              respostasCheckEdit === index &&
                                              true
                                            }
                                            onClick={(e) => {
                                              setRespostasCheckEdit(index);
                                            }}
                                          >
                                            Verdadeira
                                          </Checkbox>
                                        </Form.Item>
                                      </Col>
                                      <Col span={2} align="center">
                                        <IconClose
                                          className="icon icon-close"
                                          onClick={() =>
                                            handleRemoveCheckboxEdit(
                                              remove,
                                              field,
                                              index
                                            )
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                ))}
                              </Col>
                            </Row>
                          )}
                        </Form.List>
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Questão 2 (opcional)</h6>
                      <Input
                        placeholder="Questão 2 (opcional)"
                        name="questao_2"
                        style={styles.input_class}
                        value={questaoEvent2Edit}
                        onChange={(e) => setQuestaoEvent2Edit(e.target.value)}
                      />
                    </Col>
                    <Col span={24}>
                        <Form.List
                          name="respostas_2"
                          rules={[{ validator: validateVerdadeiraRadio }]}
                        >
                          {(fields, { add, remove }) => (
                            <Row gutter={[12, 12]}>
                              <Col span={6}>
                                <Form.Item>
                                  <Button
                                    type="primary"
                                    className="cta publish h-45"
                                    onClick={() => add()}
                                    block
                                  >
                                    Adicionar Resposta
                                  </Button>
                                </Form.Item>
                              </Col>
                              <Col span={18}>
                                {fields.map((field, index) => (
                                  <Form.Item key={field.key}>
                                    <Row gutter={[12, 12]} align={'middle'}>
                                      <Col span={18}>
                                        <Form.Item
                                          {...field}
                                          name={[field.name, "texto"]}
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Digite o texto da questão",
                                            },
                                          ]}
                                        >
                                          <Input
                                            placeholder={
                                              "Resposta " + (index + 1)
                                            }
                                            style={styles.input_class}
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col span={4} align="center">
                                        <Form.Item
                                          {...field}
                                          name={[field.name, "resposta"]}
                                        >
                                          <Checkbox
                                            checked={
                                              respostasCheckEdit2 === index &&
                                              true
                                            }
                                            onClick={(e) => {
                                              setRespostasCheckEdit2(index);
                                            }}
                                          >
                                            Verdadeira
                                          </Checkbox>
                                        </Form.Item>
                                      </Col>
                                      <Col span={2} align="center">
                                        <IconClose
                                          className="icon icon-close"
                                          onClick={() =>
                                            handleRemoveCheckboxEdit2(
                                              remove,
                                              field,
                                              index
                                            )
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                ))}
                              </Col>
                            </Row>
                          )}
                        </Form.List>
                    </Col>
                    
                  </Row>
                </Col>
              </Form>
            </Drawer>

            <Modal
              key={"remove-event-" + idToRemove}
              title="Está prestes a eliminar um caso"
              open={removeCasoModalOpen}
              onOk={handleRemoveEvent}
              onCancel={() => setRemoveCasoModalOpen(false)}
              okText="Confirmar"
              cancelText="Cancelar"
            >
              <p>
                Tem a certeza que pretende remover o caso{" "}
                <b>'{titleToRemove}'</b>?
              </p>
            </Modal>

          <DrawerCasosRespostas
            key={"drawerCasoResposta" + casoDrawer?.id}
            caso={casoDrawer}
            show={drawerRespostas}
            onChange={(e) => setDrawerRespostas(e)}
            respostas={respostasDrawer}
          />
          </WrapperCardList>
        </WrapperCardEvento>
        <Footer />
      </Content>
    </Wrapper>
  );
}
